import { useQuery } from 'react-query';
import { getUserProfile, type UserProfileResponse } from '../../services/userProfileService';

export function useGetUserProfile(userProfileId: string) {
  return useQuery<UserProfileResponse, Error, UserProfileResponse>(
    ['userProfile', userProfileId],
    () => getUserProfile(userProfileId),
    {
      enabled: !!userProfileId
    }
  );
}
